import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import logo from "../../img/Logo_SetPort.png";
import style from "./Login.module.css";

const NewLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  
  const [id, setId] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    if (!id || !senha) {
      setError("Por favor, preencha todos os campos.");
      return;
    }
    
    login(id.toLowerCase(), senha).then((res) => {
      if (res) {
        setError(res);
        return;
      }
      navigate("/dashboard");
    });
  };

  return (
    <div className={style.container}>
      <div className={style.loginBox}>
      <img src={logo} alt="Logo" className={style.logo} />
        <form onSubmit={handleLogin} className={style.form}>
          <div className={style.inputGroup}>
            <label htmlFor="user">Usuário</label>
            <input
              id="user"
              type="text"
              value={id}
              onChange={(e) => { setId(e.target.value); setError(""); }}
              required
            />
          </div>
          <div className={style.inputGroup}>
            <label htmlFor="pass">Senha</label>
            <input
              id="pass"
              type={showPassword ? "text" : "password"}
              value={senha}
              onChange={(e) => { setSenha(e.target.value); setError(""); }}
              required
            />
            <span
              className={style.togglePassword}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Ocultar" : "Mostrar"}
            </span>
          </div>
          {error && <div className={style.errorMsg}>{error}</div>}
          <button type="submit" className={style.loginButton}>Entrar</button>
        </form>
      </div>
    </div>
  );
};

export default NewLogin;
